import React from "react";
import {Form, InputGroup} from "react-bootstrap";
import SVG from "react-inlinesvg";

import remove from "../../../assets/svg/actions/icn-remove.svg";
import "../../../assets/sass/components/forms/input-group-animated.scss";

class InputGroupAnimated extends React.Component {

    inputGroupRef = React.createRef();

    state = {
        toggleInput: false,
        value: ''
    }

    static defaultProps = {
        className: "",
        icon: null,
        placeholder: null,
        onChange: () => console.log('changed'),
    }

    toggleInput = () => {
        this.setState({
            toggleInput: !this.state.toggleInput
        }, function () {
            if(this.state.toggleInput) {
                if(this.inputGroupRef.current)
                    this.inputGroupRef.current.focus();
            }
        })
    }

    clearInput = (e) => {
        e.preventDefault();
        this.setState({
            value: "",
        })
    }

    onInput = (event) => {
        this.setState({
            value: event.target.value
        })
    }

    inputGroupHtml = () => {
        var {className, icon, placeholder, onChange} = this.props;

        return (
            <div className="input-group-wrapper">
                <InputGroup className="input-group-white-lg">
                    <Form.Control ref={this.inputGroupRef} name="text" placeholder={placeholder} className={className} onChange={onChange} onInput={this.onInput} value={this.state.value}/>
                    <InputGroup.Append>
                        { this.state.value ? (
                            <InputGroup.Text className="icon remove" onClick={this.clearInput}>
                                <i><SVG src={remove}/></i>
                            </InputGroup.Text>
                        ): (
                            <InputGroup.Text className="icon">
                                <i><SVG src={icon}/></i>
                            </InputGroup.Text>
                        )}
                    </InputGroup.Append>
                </InputGroup>
            </div>
        )
    }

    iconTogglerHtml = () => {
        var {icon} = this.props;

        return (
            <a href="#" className="mr-4" onClick={this.toggleInput}><i><SVG src={icon}/></i></a>
        )
    }

    render() {
        return (
            <div className="input-group-animated">
                {this.state.toggleInput ? this.inputGroupHtml() : this.iconTogglerHtml()}
            </div>
        );
    }
};

export default InputGroupAnimated;
